import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_user_list = (page, per_page, name, status) => {
  return api.post(`${ApiEndpointConstants.GETUSERS}`, {
    page,
    per_page,
    name,
    status,
  });
};
